module.exports = __webpack_public_path__ + "media/my_images/owner/newplan-9d204f9ca99d969cd594be0c68f3d0dc.jpg";